// React
import { useState, useEffect } from 'react'

// Styles
import './ColumnModal.css'

const ColumnModal = ({ isOpen, onClose, onSave, column }) => {
    const [name, setName] = useState('')
    const [touched, setTouched] = useState(false)

    useEffect(() => {
        if (isOpen) {
            setName(column ? column.name : '')
            setTouched(false)
        }
    }, [isOpen, column])

    if (!isOpen) return null

    const validate = (v) => {
        if (!v || !v.trim()) return 'O nome da coluna é obrigatório.'
        if (/^\s*$/.test(v)) return 'O nome não pode consistir apenas em espaços em branco.'
        if (v.trim().length < 3) return 'O nome deve ter entre 3 e 100 caracteres.'
        if (v.trim().length > 100) return 'O nome deve ter entre 3 e 100 caracteres.'
        return null
    }

    const error = validate(name)
    const isFormValid = error === null

    const handleSave = () => {
        setTouched(true)
        if (!isFormValid) return
        onSave(name.trim())
        onClose()
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') handleSave()
    }

    return (
        <div className='ColumnModal-overlay' onClick={onClose}>
            <div className='ColumnModal' onClick={e => e.stopPropagation()}>
                <div className='ColumnModal-header'>
                    <h2>{column ? 'Renomear Coluna' : 'Nova Coluna'}</h2>
                    <button className='ColumnModal-close' onClick={onClose}>✕</button>
                </div>

                <div className='ColumnModal-body'>
                    <div className='ColumnModal-field'>
                        <label>Nome</label>
                        <input
                            type='text'
                            placeholder='Ex: Em Validação'
                            value={name}
                            onChange={e => setName(e.target.value)}
                            onBlur={() => setTouched(true)}
                            onKeyDown={handleKeyDown}
                            autoFocus
                        />
                        {touched && error &&
                            <span className='ColumnModal-field-error'>{error}</span>
                        }
                    </div>
                </div>

                <div className='ColumnModal-footer'>
                    <button className='ColumnModal-btn-cancel' onClick={onClose}>Cancelar</button>
                    <button
                        className='ColumnModal-btn-save'
                        onClick={handleSave}
                        disabled={!isFormValid}
                    >
                        {column ? 'Salvar' : 'Criar'}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ColumnModal